// src/pages/BlogList.js
import React, { useEffect, useState } from 'react';
import { getAllBlogs } from '../api/blogApi';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllBlogs().then(res => setBlogs(res.data)).finally(() => setLoading(false));
  }, []);

  const containerStyle = { maxWidth: '800px', margin: '50px auto', padding: '0 20px' };
  const blogStyle = {
    borderBottom: '1px solid #ccc',
    padding: '20px 0'
  };
  const titleStyle = { fontSize: '22px', marginBottom: '10px' };
  const linkStyle = { textDecoration: 'none', color: '#222' };

  if (loading) return <LoadingSpinner />;

  return (
    <div style={containerStyle}>
      <h2>Blogs</h2>
      {blogs.map(blog => (
        <div key={blog.id} style={blogStyle}>
          <Link to={`/blogs/${blog.id}`} style={linkStyle}>
            <h3 style={titleStyle}>{blog.title}</h3>
          </Link>
          <p>{blog.summary}</p>
        </div>
      ))}
    </div>
  );
};

export default BlogList;
